export const oferta = {
  nombre: 'Mega Pack Adolescencia Integral',
  detalle: '7 tomos + 5 bonos · 12 recursos educativos',
  precio: '$19.990',
  valorReal: '$49.990',
  etiqueta: 'Oferta especial de lanzamiento',
  checkoutUrl: 'https://pack-convivencia-escolar.impultienda.ar/checkout',
}

export const incluyeOferta = [
  '7 tomos completos',
  '100 actividades ESI rápidas',
  '100 casos para debatir',
  'Kit de jornadas ESI',
  '100 actividades de ciudadanía digital',
  'Guía docente para temas sensibles',
]
